export default __webpack_public_path__ + "static/media/ci.4cfd5f75.svg";